// 수익률현황 API
import axiosInstance from './axiosInstance';

// 건별수익률현황 조회
// params: { account_name, year, is_sold_n, is_sold_y }
export const fetchProfitStatus = async (params = {}) => {
  const response = await axiosInstance.get('/profit/status', { params });
  return response.data.data;
};

// 건별수익률현황 합계 조회
// params: { accounts, year }
export const fetchProfitStatusSummary = async (params = {}) => {
  const response = await axiosInstance.get('/profit/status/summary', { params });
  return response.data;
};

// 차수별현황 조회
// params: { account_name, term_type, sector }
// 반환: { data: [...], max_turn_no: N }
export const fetchTurnStatus = async (params = {}) => {
  const response = await axiosInstance.get('/profit/turn-status', { params });
  return response.data;  // { success, message, max_turn_no, data }
};
